import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Checkbox,
  Row,
  Col,
  Upload,
  Radio,
  Select,
  DatePicker,
  InputNumber,
  Button,
} from 'antd';
import { UploadOutlined, CaretRightFilled } from '@ant-design/icons';
import RenderResponseWithAns from '../renderResponseWithAnsConsent';
import { returnTable } from '../../admins/doctorAdmin/masterManagement/templateMaster/functions';
import { layout } from '../../commonImports/import1';
import radioActiveImg from '../../../assets/radio-active-new.png';
import radioInactiveImg from '../../../assets/radio-inactive-new.png';
import checkboxActiveImg from '../../../assets/checkbox-active-new.png';
import checkboxInactiveImg from '../../../assets/checkbox-inactive-new.png';

// Custom styled checkbox that uses the image assets but preserves the original Checkbox functionality
const StyledCheckbox = (props) => {
  // State to force updates when form values change
  const [, forceUpdate] = useState({});
  
  // Effect to listen for form value changes
  useEffect(() => {
    const intervalId = setInterval(() => {
      // This will force the component to re-check the form values
      forceUpdate({});
    }, 200);
    
    return () => clearInterval(intervalId);
  }, []);
  
  // Get the checked state from props or form values
  const isChecked = props.checked !== undefined ? 
                    props.checked : 
                    (props.value && props.form && Array.isArray(props.form.getFieldValue([props.name, 'answer'])) && 
                    props.form.getFieldValue([props.name, 'answer'])?.includes(props.value));
  
  return (
    <span className="custom-checkbox-wrapper" style={{ 
      position: 'relative', 
      display: 'inline-flex', 
      alignItems: 'center', 
      cursor: 'pointer',
      padding: '8px 0'
    }}>
      <Checkbox 
        {...props} 
        style={{ 
          opacity: 0, 
          position: 'absolute', 
          width: '100%', 
          height: '100%', 
          margin: 0, 
          zIndex: 1,
          cursor: 'pointer',
          left: 0,
          top: 0
        }}
      />
      <img 
        src={isChecked ? checkboxActiveImg : checkboxInactiveImg} 
        alt={isChecked ? "Checked" : "Unchecked"}
        style={{ width: '32px', height: '32px', marginRight: '8px', pointerEvents: 'none' }}
      />
      <span style={{ pointerEvents: 'none' }}>{props.children}</span>
    </span>
  );
};

// Custom styled radio that uses the image assets but preserves the original Radio functionality
const StyledRadio = (props) => {
  // State to force updates when form values change
  const [, forceUpdate] = useState({});
  
  // Effect to listen for form value changes
  useEffect(() => {
    const intervalId = setInterval(() => {
      // This will force the component to re-check the form values
      forceUpdate({});
    }, 200);
    
    return () => clearInterval(intervalId);
  }, []);
  
  // Get the checked state from props or determine it from the value and onChange
  const isChecked = props.checked !== undefined ? props.checked : false;
  
  return (
    <span className="custom-radio-wrapper" style={{ 
      position: 'relative', 
      display: 'inline-flex', 
      alignItems: 'center', 
      cursor: 'pointer',
      padding: '8px 0'
    }}>
      <Radio 
        {...props} 
        style={{ 
          opacity: 0, 
          position: 'absolute', 
          width: '100%', 
          height: '100%', 
          margin: 0, 
          zIndex: 1,
          cursor: 'pointer',
          left: 0,
          top: 0
        }}
      />
      <img 
        src={isChecked ? radioActiveImg : radioInactiveImg} 
        alt={isChecked ? "Selected" : "Unselected"}
        style={{ width: '32px', height: '32px', marginRight: '8px', pointerEvents: 'none' }}
      />
      <span style={{ pointerEvents: 'none' }}>{props.children}</span>
    </span>
  );
};

const renderElement = (
  props,
  form,
  p,
  name,
  elemType,
  onChange,
  uploadList,
  custObj
) => {
  const style = { width: '100%' };

  const uploadButtonPicture = (isDisabled) => (
    <Button disabled={isDisabled}>
      <UploadOutlined /> Upload
    </Button>
  );

  let elem;

  switch (elemType) {
    case 'CHECK_BOX':
      elem = (
        <Checkbox.Group 
          style={{ width: '100%' }} 
          onChange={(checkedValues) => {
            console.log(checkedValues, "checkbox");
            onChange(checkedValues);
            // Force parent component to update
            if (props.rerenderCustom) {
              props.rerenderCustom();
            }
          }}
        >
          <Row>
            {p.checkboxList.map((m) => {
              const flag = custObj?.attachedQuestions?.find(
                (a) => a.attachedVal === m.optionTitle
              );
              
              // Get the current form values to determine if this checkbox is checked
              const currentValues = form.getFieldValue([name, 'answer']) || [];
              const isChecked = Array.isArray(currentValues) && currentValues.includes(m.optionTitle);
              
              return (
                <Col
                  span={custObj.attachedQuestions?.length > 0 ? 24 : 12}
                  key={m.optionTitle}
                >
                  <StyledCheckbox 
                    value={m.optionTitle} 
                    checked={isChecked}
                    form={form}
                    name={name}
                    onClick={() => {
                      // Handle manual click to update state immediately
                      const currentVals = form.getFieldValue([name, 'answer']) || [];
                      const newVals = isChecked 
                        ? currentVals.filter(v => v !== m.optionTitle)
                        : [...currentVals, m.optionTitle];
                        
                      form.setFieldsValue({
                        [name]: { answer: newVals }
                      });
                      
                      if (props.rerenderCustom) {
                        props.rerenderCustom();
                      }
                    }}
                  >
                    {m.optionTitle} {flag ? <CaretRightFilled /> : null}
                  </StyledCheckbox>
                  {flag && (
                    <Col
                      flex={2}
                      style={{ border: '1px solid #ccc', padding: '0px 10px' }}
                    >
                      {custObj.attachedQuestions.map(
                        (a) =>
                          a.attachedVal === m.optionTitle && (
                            <RenderResponseWithAns
                              key={a.attachedVal}
                              rerenderCustom={() => {
                                if (props.rerenderCustom) {
                                  props.rerenderCustom();
                                }
                              }}
                              layout={layout}
                              record={a}
                              form={form}
                              chat={false}
                              attachedQuestions={[]}
                            />
                          )
                      )}
                    </Col>
                  )}
                </Col>
              );
            })}
          </Row>
        </Checkbox.Group>
      );
      break;

    case 'RADIO_BUTTON':
      const radioOptions = p.radioList || [];
      const includeNotApplicable = p.addNotApplicable === 'true';
      const uniqueOptions = new Set(
        radioOptions.map((option) => option.optionTitle)
      );

      if (p.radioDisplayType === 'DROPDOWN') {
        elem = (
          <Select
            placeholder="Select Answer"
            allowClear
            style={{ width: '300px' }}
            onChange={(value) => {
              onChange(value);
              // Force parent component to update
              if (props.rerenderCustom) {
                props.rerenderCustom();
              }
            }}
          >
            {radioOptions.map((item) => (
              <Select.Option key={item.optionTitle} value={item.optionTitle}>
                {item.optionTitle}
              </Select.Option>
            ))}
            {includeNotApplicable && !uniqueOptions.has('Not Applicable') && (
              <Select.Option value={null}>Not Applicable</Select.Option>
            )}
          </Select>
        );
      } else {
        elem = (
          <Radio.Group
            className={props.chat ? 'chatresponse-wrapper' : ''}
            style={{ width: '100%' }}
            onChange={(e) => {
              console.log(e, "radio");
              onChange(e);
              // Force parent component to update
              if (props.rerenderCustom) {
                props.rerenderCustom();
              }
            }}
          >
            {radioOptions.map((m) => {
              const flag = custObj?.attachedQuestions?.find(
                (a) => a.attachedVal === m.optionTitle
              );
              
              // Get the current form value to determine if this radio is checked
              const currentValue = form.getFieldValue([name, 'answer']);
              const isChecked = currentValue === m.optionTitle;
              
              return (
                <Row key={m.optionTitle}>
                  <Col flex={1}>
                    <StyledRadio 
                      value={m.optionTitle} 
                      checked={isChecked}
                      onClick={() => {
                        // Handle manual click to update state immediately
                        form.setFieldsValue({
                          [name]: { answer: m.optionTitle }
                        });
                        
                        if (props.rerenderCustom) {
                          props.rerenderCustom();
                        }
                      }}
                    >
                      {m.optionTitle} {flag ? <CaretRightFilled /> : null}
                    </StyledRadio>
                  </Col>
                  {flag && (
                    <Col
                      flex={2}
                      style={{ border: '1px solid #ccc', padding: '0px 10px' }}
                    >
                      {custObj.attachedQuestions.map((a) => {
                        if (a.attachedVal === m.optionTitle) {
                          return (
                            <RenderResponseWithAns
                              key={a.attachedVal}
                              rerenderCustom={() => {
                                if (props.rerenderCustom) {
                                  props.rerenderCustom();
                                }
                              }}
                              record={a}
                              full
                              form={form}
                              chat={false}
                              attachedQuestions={[]}
                            />
                          );
                        }
                        return null;
                      })}
                    </Col>
                  )}
                </Row>
              );
            })}
            {includeNotApplicable && !uniqueOptions.has('Not Applicable') && (
              <StyledRadio 
                value={null} 
                checked={form.getFieldValue([name, 'answer']) === null}
                onClick={() => {
                  // Handle manual click to update state immediately
                  form.setFieldsValue({
                    [name]: { answer: null }
                  });
                  
                  if (props.rerenderCustom) {
                    props.rerenderCustom();
                  }
                }}
              >
                Not Applicable
              </StyledRadio>
            )}
          </Radio.Group>
        );
      }
      break;

    case 'FREE_TEXT':
      elem =
        p.freeText.textInputType === 'SINGLE_LINE' ? (
          <Input style={style} placeholder="Answer" />
        ) : (
          <Input.TextArea style={style} placeholder="Answer" />
        );
      break;

    case 'NUMBER':
      elem = <InputNumber style={style} placeholder="Answer" />;
      break;

    case 'DATE':
      elem = <DatePicker style={style} />;
      break;

    case 'FILE':
      elem = (
        <Upload
          name="avatar"
          listType="picture"
          className="avatar-uploader"
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        >
          {uploadList.length > 0
            ? uploadButtonPicture(true)
            : uploadButtonPicture(false)}
        </Upload>
      );
      break;

    case 'TABLE':
      elem = returnTable(p, props, { answers: custObj.answers });
      break;

    case 'FILL_IN_BLANKS':
      const regex = /[_]+/g;
      const arr = p.fillInBlanks.answerSummary.split(regex);
      const typeArray = p.fillInBlanks.blanksType || [];
      elem = (
        <Input.Group>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'self-start',
            }}
          >
            {arr.map((a, i) => {
              const type = typeArray[i];
              const inputElem =
                type && type.type === 'select' ? (
                  <Select
                    placeholder="Select Answer"
                    style={{
                      width: 'auto',
                      minWidth: '100px',
                      marginLeft: '5px',
                      marginRight: '5px',
                    }}
                  >
                    {type.values.map((val) => (
                      <Select.Option value={val} key={val}>
                        {val}
                      </Select.Option>
                    ))}
                  </Select>
                ) : (
                  <Input
                    style={{
                      width: 'auto',
                      marginLeft: '5px',
                      marginRight: '5px',
                      border: '0px',
                      borderBottom: '1px solid grey',
                    }}
                  />
                );

              return i !== arr.length - 1 ? (
                <>
                  <p key={i}>{a}</p>
                  <Form.Item
                    name={[p.slugValueNew, 'answer', i]}
                    noStyle
                    rules={[{ required: false }]}
                  >
                    {inputElem}
                  </Form.Item>
                </>
              ) : (
                <p key={i}>{a}</p>
              );
            })}
          </div>
        </Input.Group>
      );
      break;

    default:
      elem = <Input style={style} placeholder={p.name} />;
  }

  return elem;
};

export default renderElement;